import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './allocationRequestTypeChangeOrder.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString, host: {'forUniqueComponentId': 'fafeafaefesfeaa'}
})
export class AllocationRequestTypeChangeOrderComponent implements OnInit {
    @Output() action = new EventEmitter();
    
    public originalAllocationRequestTypes: any;
    
    public allocationRequestTypes: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2
    ) { 
        this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok() {
        this.http.post("allocation_request_types/update_order", { allocation_request_type_ids: this.allocationRequestTypes.map(function(x) { return x.id; }) }).subscribe(() => {
            this.action.emit(true);
            this.bsModalRef.hide();
		});
    }

    cancel() {
        this.bsModalRef.hide();
    };

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.allocationRequestTypes, event.previousIndex, event.currentIndex);
    }

    ngOnInit() {
        this.allocationRequestTypes = JSON.parse(JSON.stringify(this.originalAllocationRequestTypes));
    }
}
